import { getDaysHoursMinsFromDateNumeric } from './get-days-hours-mins-from-date';
import { MILLISECONDS_IN_DAY, MILLISECONDS_IN_MINUTE } from './time-constants';

export const getIterationStart = (
  isEnd: boolean,
  isStartAndEndSameDay: boolean,
  startDateNumeric: number,
  endDateNumeric: number,
  firstPossibleCalcMinutes: number,
  millisecondsTimezoneOffset: number
): number => {
  if (isEnd) {
    if (isStartAndEndSameDay) {
      // start calculating dates at the startDateZoned
      return startDateNumeric + millisecondsTimezoneOffset;
    } else {
      const dateNumberStats = getDaysHoursMinsFromDateNumeric(endDateNumeric + millisecondsTimezoneOffset);
      // start calculating dates at the earliest minutes in to the endDateZoned possible based on generatedOptionIncrementMinutes
      return dateNumberStats.days * MILLISECONDS_IN_DAY + firstPossibleCalcMinutes * MILLISECONDS_IN_MINUTE;
    }
  } else {
    // start calculating dates at firstPossibleCalcMinutes minutes in to startDateZoned
    // firstPossibleCalcMinutes may be 0 in which case all options will be generated based on generatedOptionIncrementMinutes
    // if firstPossibleCalcMinutes is not 0, it reflects the start

    if (!firstPossibleCalcMinutes) {
      const dateNumberStats = getDaysHoursMinsFromDateNumeric(startDateNumeric + millisecondsTimezoneOffset);

      // beginning of the day
      return dateNumberStats.days * MILLISECONDS_IN_DAY;
    } else {
      // we have a value for firstPossibleCalcMinutes so we will start at the startDateZoned
      return startDateNumeric + millisecondsTimezoneOffset;
    }
  }
};
